export default __webpack_public_path__ + "static/media/avi-shushan.709c69b0.png";